export var PaymentProviderEnum;
(function (PaymentProviderEnum) {
    PaymentProviderEnum["SQUARE"] = "square";
    PaymentProviderEnum["AUTHORIZE"] = "authorize";
    PaymentProviderEnum["TOAST_SPREEDLY"] = "toast_spreedly";
    PaymentProviderEnum["CLOVER"] = "clover";
})(PaymentProviderEnum || (PaymentProviderEnum = {}));
//# sourceMappingURL=PaymentProviderEnum.js.map